import React, { useEffect, useRef, useState } from 'react'
import api from '../../../api';
import { Dropdown } from 'primereact/dropdown';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  Legend, BarChart, Bar,
  PieChart,
  Pie,
  Cell
} from 'recharts';
import { ProgressSpinner } from 'primereact/progressspinner';


const HCWData = () => {

        const currentDate1 = new Date();
        const formattedCurrentDate = `${currentDate1.getDate().toString().padStart(2, '0')}-${(currentDate1.getMonth() + 1).toString().padStart(2, '0')}-${currentDate1.getFullYear()} ${currentDate1.getHours().toString().padStart(2, '0')}:${currentDate1.getMinutes().toString().padStart(2, '0')}:${currentDate1.getSeconds().toString().padStart(2, '0')}`;
        const userID = sessionStorage.getItem("UserID");
        const roleID = sessionStorage.getItem("RoleID");
        const [loading, setLoading] = useState(false);
        const toast = useRef(null);
    
        const typeName = [
          { id: "1", label: "Control" },
          { id: "2", label: "Intervention" },
        ];
    
        const [selectedSite, setSelectedSite] = useState({ site_code: "" });
        const [selectedType, setSelectedType] = useState("");
        const [date, setDate] = useState(null);
        const [date1, setDate1] = useState(null);
        
    
        const [site, setSite] = useState([]);
        const getSite = async () => {
          try {
        setLoading(true);

            const requestData = {
              logged_in_userid : userID,
              role_id : roleID,
              state_id: "",
              synceddatetime : formattedCurrentDate,
              FormCode : "202",
              ApiKey : "kavin",
              AppTypeNo : "3",
              AppVersion : "1.0.0",
              data_source : "W"
            };
              const result = await api.get_Filter_Site(requestData);
              const sitesData = result.site_admin_details.map((site) => ({
              label: site.fld_site_name,
              value: site.fld_site_name,
              site_code: site.fld_site_id,
              site_swid: site.fld_site_sw_id
            }));
    
            setSite(sitesData);
          } catch (error) {
            console.error("Error fetching site:", error);
          } finally {
        setLoading(false);
    }
        };
    
        useEffect(() => {
          getSite();
        }, []);

    const [participantsFromLastTwoWeeksData, setParticipantsFromLastTwoWeeksData] = useState([]);
    const [participantsScreeenedData, setParticipantsScreeenedData] = useState(0);
    const [participantsAssessedData, setParticipantsAssessedData] = useState(0);
    const [patientsMildDepressionData, setPatientsMildDepressionData] = useState(0);
    const [participantsReferredData, setParticipantsReferredData] = useState(0);
    const [pendingBaselineCounsellingData, setPendingBaselineCounsellingData] = useState([]);
    const [participantsCompletingFollowupsData, setParticipantsCompletingFollowupsData] = useState([]);
    const [pendingFollowupData, setPendingFollowupData] = useState([]);
    const [noCounsellingSessionsDoneData, setNoCounsellingSessionsDoneData] = useState([]);



    const getOverall = async () => {
        try {
        setLoading(true);

        const requestData = {
            role_code : roleID,
	        login_user_id : userID,
            state_id : "",
            from_month_id : "",
            to_month_id : "",
            from_year_id : "",
            to_year_id : "",
	        prs_id :"",
	        prs_name :"",
	        phc_type_id : "",
	        phc_type_name :"",
	        phc_id :"",
	        phc_name :"",
	        site_id :"",
	        site_name :"",
            request_table : {
                HcwSiteAdminDashboard : "",
            },
            synceddatetime : "02-07-2025 11:14:18",
            FormCode : "218",
            ApiKey : "kavin",
            AppTypeNo : "3",
            AppVersion : "1.0.0",
            Data_source : "W"
        };
        const result = await api.get_HCW_Dashboard(requestData);

        const participantsFromLastTwoWeeks = result?.responsemessage?.HcwSiteAdminDashboard?.[0]?.ParticipantsAllottedInLastTwoWeeks || [];
            const formattedFromLastTwoWeeks = participantsFromLastTwoWeeks.map(item => ({
              phcName: item.fld_phc_name,
              participantsAllotted: Number(item.participants_allotted)
            }));

        const participantsScreeened = result?.responsemessage?.HcwSiteAdminDashboard?.[0]?.ParticipantsScreeened?.[0]?.participants_screeened ?? null;
        const participantsAssessed = result?.responsemessage?.HcwSiteAdminDashboard?.[0]?.ParticipantsAssessed?.[0]?.participants_assessed ?? null;
        const patientsMildDepression = result?.responsemessage?.HcwSiteAdminDashboard?.[0]?.PatientsWithMildDepression ?? null;
        const participantsReferred = result?.responsemessage?.HcwSiteAdminDashboard?.[0]?.ParticipantsReferred?.[0]?.no_of_participant_needing_referral ?? null;

        const pendingBaselineCounselling = result?.responsemessage?.HcwSiteAdminDashboard?.[0]?.PendingBaselineCounselling || [];
            const noofpendingBaselineCounselling = pendingBaselineCounselling.map(item => ({
              phcName: item.fld_phc_name,
              Identified_for_intervention: Number(item.no_of_participant_identified_for_intervention),
              Undergoing_baseline_counselling: Number(item.no_of_participants_undergoing_baseline_counselling),
              pending_baseline_counselling: Number(item.pending_baseline_counselling),
            }));

        const participantsCompletingFollowups = result?.responsemessage?.HcwSiteAdminDashboard?.[0]?.ParticipantsCompletingAllFollowUps || [];
            const formattedCompletingFollowups = participantsCompletingFollowups.map(item => ({
                phcName: item.fld_phc_name,
                Completing_all_follow_ups: Number(item.participants_completing_all_follow_ups),
            }));

        const pendingFollowupRaw = result?.responsemessage?.HcwSiteAdminDashboard?.[0]?.PendingFollowUpCounsellingF1F2F3F4 || [];
            const formattedPendingFollowup = pendingFollowupRaw.map(item => ({
              name: item.fld_phc_name,
              pending: Number(item.pending_follow_up_counselling_f1_f2_f3_f4)
            }));

        const noCounsellingSessionsDone = result?.responsemessage?.HcwSiteAdminDashboard?.[0]?.NoOfCounsellingSessionsDone || [];
            const formattedFromSessionsDone = noCounsellingSessionsDone.map(item => ({
              phcName: item.fld_phc_name,
              totalExpectedSessions: Number(item.total_expected_sessions)
            }));


        setParticipantsFromLastTwoWeeksData(formattedFromLastTwoWeeks);
        setParticipantsScreeenedData(participantsScreeened);
        setParticipantsAssessedData(participantsAssessed);
        setPatientsMildDepressionData(patientsMildDepression);
        setParticipantsReferredData(participantsReferred);
        setPendingBaselineCounsellingData(noofpendingBaselineCounselling);
        setParticipantsCompletingFollowupsData(formattedCompletingFollowups);
        setPendingFollowupData(formattedPendingFollowup);
        setNoCounsellingSessionsDoneData(formattedFromSessionsDone);



      } catch (error) {
        console.error("Error fetching site:", error);
      } finally {
        setLoading(false);
    }
    };

    useEffect(() => {
      getOverall();
    }, []);



        const formik = useFormik({
        initialValues: {
          site_name:"",
          taluk_name:"",
          prs_name:"",
          village_name:"",
          phc_name:"",
          phc_type_name:""
        },
        validationSchema: Yup.object({
          site_name: Yup.string().required("Site Code is required"),
          taluk_name: Yup.string().required("Taluk Name is required"),
          prs_name: Yup.string().required("PRS Name is required"),
          village_name: Yup.string().required("Village Name is required"),
          phc_name: Yup.string().required("PHC Name is required"),
          phc_type_name: Yup.string().required("PHC Type is required"),
    
    
        }),
    
        onSubmit: async (values, { resetForm }) => {
          try {
            setLoading(true);
            const additionalData = {
              // state_id: selectedState?.state_code || "",
              state_id: values.state_code,
              district_id: values.district_code,
              site_id: values.site_code,
              taluk_id: values.taluk_code,
              fld_mapped_prs_id: values.prs_userID,
              village_id: values.village_code,
              phc_name: values.phc_name,
              phc_type_name: values.phc_type_name,
              phc_type_id: values.phc_type_id,
              synceddatetime: formattedCurrentDate,
              FormCode: "202",
              ApiKey: "kavin",
              AppTypeNo: "3",
              AppVersion: "1.0.0",
              data_source: "W",
              loggedin_user_id: userID,
            };
    
            const response = await api.add_PHC(additionalData);
    
            if (response && response.status === "1") {
              toast.current.show({
                severity: "success",
                summary: "PHC Created Successful",
                detail:
                  response.responsemessage ||
                  "You have successfully created the PHC.",
              });
              resetForm();
            } else {
              throw new Error(
                response
                  ? response.responsemessage ||
                    "An error occurred while creating the PHC."
                  : "No response from the server."
              );
            }
          } catch (error) {
            console.error("PHC submission error:", error);
    
            toast.current.show({
              severity: "error",
              summary: " PHC Failed",
              detail:
                error.message || "An unexpected error occurred. Please try again.",
            });
          } finally {
            setLoading(false);
        }
        },
        });
    
  return (
    <div>
        {loading && (
            <div className="backdrop">
                <ProgressSpinner style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
            </div>
        )}
                {/* <div className='flex justify-content-between align-items-center'>
                    <Dropdown
                       id="site_name"
                       name="site_name"
                       placeholder="Select Site"
                       value={formik.values.site_name}
                       className= "dashboard-dropdown-filter"
                       options={site}
                       disabled={roleID === "2"}
                       onChange={(e) => {
                         const selectedSite = site.find(
                           (siteObj) => siteObj.value === e.value
                         );
                         setSelectedSite(selectedSite);
                         formik.setFieldValue("site_name", e.value);
                         if (selectedSite) {
                           formik.setFieldValue("site_code", selectedSite.site_code || "");
                           formik.setFieldValue("site_sw_id", selectedSite.site_swid || "");
                         } else {
                           formik.setFieldValue("site_code", "");
                           formik.setFieldValue("site_sw_id", "");
                           setSite([]);
                         }
                       }}
                    />
        
                    <Dropdown
                      id="phc_type_name"
                      name="phc_type_name"
                      placeholder="Select PHC Type"
                      className= "dashboard-dropdown-filter"
                      options={typeName}
                      value={selectedType}
                      onChange={(e) => {
                        const selectedType = e.value;
                        formik.setFieldValue("phc_type_id", selectedType.id);
                        formik.setFieldValue("phc_type_name", selectedType.label);
                        setSelectedType(selectedType);
                      }}
                    />
        
                    <Calendar
                       id="fld_from_month_name"
                       name="fld_from_month_name"
                       placeholder="Enter Month & Year"
                       value={date}
                       showButtonBar={!!date}
                       className= "dasboardCalendar"
                       onChange={(e) => {
                        if (!e.value) {
                            // Clear the month/year fields when the calendar is cleared
                            setDate(null);
                            formik.setFieldValue("from_year_id", "");
                            formik.setFieldValue("from_month_id", "");
                            formik.setFieldValue("fld_from_month_name", "");
                        } else {
                            setDate(e.value);
                            const selectedDate = new Date(e.value);
                            const selectedMonthid = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
                            const selectedYear = selectedDate.getFullYear();
                            formik.setFieldValue("from_year_id", selectedYear);
                            formik.setFieldValue("from_month_id", selectedMonthid);
                            formik.setFieldValue("fld_from_month_name", e.value);
                        }
                    }}
                       dateFormat="mm/yy"
                       view="month"
                       showIcon
                       onBlur={formik.handleBlur}
                       maxDate={new Date()}
                   />
                    <Calendar
                      id="fld_to_month_name"
                      name="fld_to_month_name"
                      placeholder="Enter Month & Year"
                      value={date1}
                      showButtonBar={!!date1} 
                      className= "dasboardCalendar"
                      onChange={(e) => {
                        if (!e.value) {
                            setDate1(null);
                            formik.setFieldValue("to_year_id", "");
                            formik.setFieldValue("to_month_id", "");
                            formik.setFieldValue("fld_to_month_name", "");
                        } else {
                            setDate1(e.value);
                            const selectedDate = new Date(e.value);
                            const selectedMonthid = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
                            const selectedYear = selectedDate.getFullYear();
                            formik.setFieldValue("to_year_id", selectedYear);
                            formik.setFieldValue("to_month_id", selectedMonthid);
                            formik.setFieldValue("fld_to_month_name", e.value);
                        }
                    }}
                      dateFormat="mm/yy"
                      view="month"
                      showIcon
                      onBlur={formik.handleBlur}
                      maxDate={new Date()}
                  />
        
                    <div>
                   <Button className="filterFormbutton" type="submit" label='View'/>
                   <Button className="filterClearButton" type="button"  label="Clear"
                    severity="danger" outlined  />
                    </div>
        
                </div> */}

        <div className='layout'>
          <h4 className='mb-4 mt-0'>No of participants screened positive by health worker</h4>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={participantsFromLastTwoWeeksData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="phcName" style={{ fontSize: "12px" }} />
              <YAxis style={{ fontSize: "12px" }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: "12px" }}/>
              <Line type="monotone" dataKey="participantsAllotted" stroke="#ff7300" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className='grid m-0 mt-5 gap-2'>
          <div className='col layout'>
            <h2 className="m-0">{participantsScreeenedData}</h2>
            <p className="pr-4 dashboardText">Participants Screeened</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{participantsAssessedData}</h2>
            <p className="pr-4 dashboardText">Participants Assessed</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{patientsMildDepressionData}</h2>
            <p className="pr-4 dashboardText">Patients with mild depression</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{participantsReferredData}</h2>
            <p className="pr-4 dashboardText">Participants referred</p>
          </div>
        </div>

        <div className='mt-5 layout'>
          <h4 className='mb-4 mt-0'>Pending baseline counselling</h4>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={pendingBaselineCounsellingData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="phcName" style={{ fontSize: "12px" }} />
              <YAxis style={{ fontSize: "12px" }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: "12px" }}/>
              <Bar dataKey="Identified_for_intervention" stackId="a" fill="#82ca9d" />
              <Bar dataKey="Undergoing_baseline_counselling" stackId="a" fill="#ffc658" />
              <Bar dataKey="pending_baseline_counselling" stackId="a" fill="#ff7f50" />
            </BarChart>
          </ResponsiveContainer>
        </div>


        <div className='mt-5 layout'>
          <h4 className='mb-4 mt-0'>Participants completing all Follow-ups</h4>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={participantsCompletingFollowupsData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="phcName" style={{ fontSize: "12px" }} />
              <YAxis style={{ fontSize: "12px" }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: "12px" }}/>
              <Bar dataKey="Completing_all_follow_ups" fill="#82ca9d" barSize={30}/>
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className='mt-5 layout'>
          <h4 className='mb-4 mt-0'>Pending Follow-up counselling (F1, F2, F3, F4)</h4>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={pendingFollowupData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" style={{ fontSize: "12px" }} />
              <YAxis style={{ fontSize: "12px" }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: "12px" }} />
              <Bar dataKey="pending" fill="#82ca9d" barSize={30}/>
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className='mt-5 layout'>
          <h4 className='mb-4 mt-0'>No of counselling sessions done</h4>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={noCounsellingSessionsDoneData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="phcName" style={{ fontSize: "12px" }} />
              <YAxis style={{ fontSize: "12px" }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: "12px" }}/>
              <Line type="monotone" dataKey="totalExpectedSessions" stroke="#ff7300" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </div>


    </div>
  )
}

export default HCWData